//文字コードはutf-8

/* IRトップページ ニュース表示
========================================================*/
export function initIrTop() {
    var $ = jQuery;
    var moment = window.moment;

    var $list = $('#list[data-len]');

    if (!$list.length || !$('#tpl-list').length || $('#filterMenu').length) return;

    if (!window.IR_CONFIG || !$.views || !moment) {
        $list.html('<p class="modIRNewsMessage modIRNewsMessage--error">IRニュースの取得に失敗しました。時間をおいて再度お試しください。</p>');
        return;
    }

    var COMPANY_CODE = window.IR_CONFIG.COMPANY_CODE;
    var API_URL = window.IR_CONFIG.API_URL;
    var groupLabel = window.IR_CONFIG.groupLabel;
    var maxLen = parseInt($list.data('len'), 10) || 4;

    function decodeEntities(value) {
        if (value == null) return '';
        return $('<div/>').html(String(value)).text();
    }

    function escapeHtml(value) {
        return decodeEntities(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function formatDate(value, format) {
        var date = moment(new Date(value));
        if (!date.isValid()) return '';
        return date.format(format);
    }

    function formatFileSize(size) {
        var units = ['Byte', 'KB', 'MB', 'GB'];
        var unitIndex = 0;
        var parsedSize = parseInt(size, 10);
        if (!parsedSize) return '';
        while (parsedSize >= 1024 && unitIndex < units.length - 1) {
            parsedSize = parsedSize / 1024;
            unitIndex++;
        }
        parsedSize = unitIndex >= 2 ? Math.round(parsedSize * 10) / 10 : Math.round(parsedSize);
        return parsedSize + units[unitIndex];
    }

    function formatFileInfo(file) {
        if (!file) return '';
        var size = formatFileSize(file.size);
        var page = parseInt(file.page, 10);
        var pageText = page ? '/' + page + 'P' : '';
        return size ? '（' + size + pageText + '）' : '';
    }

    function findCategory(code) {
        var parsedCode = parseInt(code, 10);
        var category;
        for (category in groupLabel) {
            if ($.inArray(parsedCode, groupLabel[category].doctype) !== -1) {
                return { name: category, id: groupLabel[category].id };
            }
        }
        return { name: 'その他', id: 0 };
    }

    function findFile(files, fileType) {
        var result = null;
        if (!$.isArray(files)) return null;
        $.each(files, function (_, file) {
            if (file.type === fileType) {
                result = file;
                return false;
            }
        });
        return result || files[0] || null;
    }

    function isPdfUrl(url) {
        return /\.pdf(?:[?#].*)?$/i.test(url);
    }

    function isExternalUrl(url) {
        try {
            var parsedUrl = new URL(url, window.location.href);
            return parsedUrl.hostname !== window.location.hostname;
        } catch (error) {
            return false;
        }
    }

    function isNewDate(value) {
        var date = moment(new Date(value));
        if (!date.isValid()) return false;
        return moment().diff(date, 'days') < 30;
    }

    function getAllDoctypes() {
        var doctypes = [];
        var seen = {};
        var result = [];
        var i;

        $.each(groupLabel, function (_, config) {
            doctypes = doctypes.concat(config.doctype);
        });

        for (i = 0; i < doctypes.length; i++) {
            if (!seen[doctypes[i]]) {
                seen[doctypes[i]] = true;
                result.push(doctypes[i]);
            }
        }

        return result.join(',');
    }

    $.views.converters({
        date: function (value) {
            var format = this.tagCtx.props.format || 'YYYY年M月D日';
            return formatDate(value, format);
        },
        link: function (files) {
            var props = this.tagCtx.props;
            var file = findFile(files, props.fileType);
            var title = props.text || '';
            var category = findCategory(props.disclosureCode);
            var dateTime = formatDate(props.publishDate, 'YYYY-MM-DD');
            var dateText = formatDate(props.publishDate, 'YYYY.MM.DD');
            var fileInfo = formatFileInfo(file);
            var url = file && file.url ? encodeURI(file.url) : '';
            var tagName = url ? 'a' : 'span';
            var classes = ['modListNews__item__link'];
            var attrs = '';
            var newHtml = isNewDate(props.publishDate) ? '<span class="new">NEW</span>' : '';

            if (url) {
                attrs += ' href="' + escapeHtml(url) + '"';
                if (isPdfUrl(url)) {
                    classes.push('pdf');
                    classes.push('modListNews__item__link--pdf');
                } else if (isExternalUrl(url)) {
                    classes.push('blank');
                    classes.push('modListNews__item__link--external');
                }
                if (isPdfUrl(url) || isExternalUrl(url)) {
                    attrs += ' target="_blank" rel="noopener noreferrer"';
                }
            } else {
                attrs += ' aria-disabled="true"';
                classes.push('irNewsLink--disabled');
            }

            attrs += ' class="' + classes.join(' ') + '"';

            return '<' + tagName + attrs + '>' +
                '<div class="heading"><h3>' + escapeHtml(title) +
                (fileInfo ? '<span class="unit">' + escapeHtml(fileInfo) + '</span>' : '') +
                '</h3></div>' +
                '<time class="date" datetime="' + escapeHtml(dateTime) + '">' + escapeHtml(dateText) + '</time>' +
                '<span class="tag irCat irCat_' + escapeHtml(category.id) + '">' + escapeHtml(category.name) + '</span>' +
                newHtml +
                '</' + tagName + '>';
        }
    });

    $.ajax({
        url: API_URL,
        type: 'GET',
        cache: false,
        dataType: 'jsonp',
        data: {
            company: COMPANY_CODE,
            output: 'json',
            len: maxLen,
            doctype: getAllDoctypes()
        }
    }).done(function (response) {
        var items = (response && response.items) || [];

        items.sort(function (a, b) {
            return new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime();
        });

        items = items.slice(0, maxLen);

        $list.html($('#tpl-list').render({
            items: items,
            length: items.length
        }));
    }).fail(function () {
        $list.html('<p class="modIRNewsMessage modIRNewsMessage--error">IRニュースの取得に失敗しました。時間をおいて再度お試しください。</p>');
    });
}
